import { createRootRoute, Outlet, useRouterState } from '@tanstack/react-router';
import { Toaster } from '@/components/ui/toaster';

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  const isLoading = useRouterState({ select: (s) => s.status === 'pending' });
  return (
    <>
      <div
        className={`min-h-screen relative ${isLoading ? 'opacity-90' : 'opacity-100'} transition-opacity`}
      >
        <Outlet />
      </div>
      <Toaster />
    </>
  );
}
